/** Shared credit / skip shapes for bank → Tally parsers (PNB, HDFC, …). */

export const BANK_SKIP_REASON_DEBIT = "Debit transaction";

export type BankCreditTxn = {
  txnNo: string;
  /** Calendar day from the statement (local midnight). */
  txnDate: Date;
  description: string;
  amount: number;
};

export type BankSkippedRow = {
  reason: string;
  /** 1-based row number in the sheet/CSV (including header/noise). */
  rowNumber: number;
  txnNo?: string;
  txnDateRaw?: string;
  description?: string;
  amount?: number;
};

export type BankParseResult = {
  credits: BankCreditTxn[];
  skipped: BankSkippedRow[];
};

export class BankParseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "BankParseError";
  }
}
